import { NgClass } from '@angular/common'
import { CommonModule } from '@angular/common'
import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { RouterModule } from '@angular/router'
import { WA_WINDOW } from '@ng-web-apis/common'
import { EasyHeaderDefaultComponent } from '../../../headers/components/easy-header-default/easy-header-default.component'
import { SidebarEasyModeComponent } from '../../../sidebars/components/sidebar-easy-mode/sidebar-easy-mode.component'
import { EasyMobileNavComponent } from '../easy-mobile-nav/easy-mobile-nav.component'
@Component({
    selector: 'app-layout-easy-mode',
    imports: [
        EasyHeaderDefaultComponent,
        SidebarEasyModeComponent,
        NgClass,
        RouterModule,
        EasyMobileNavComponent,
        CommonModule,
    ],
    templateUrl: './layout-easy-mode.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './layout-easy-mode.component.css',
})
export class LayoutEasyModeComponent {
    private windowRef = inject(WA_WINDOW)
    isSidebarCollapsed = false
    isMobileSidebarOpen = false

    toggleSidebar() {
        if (this.windowRef.innerWidth <= 768) {
            this.isMobileSidebarOpen = !this.isMobileSidebarOpen
        } else {
            this.isSidebarCollapsed = !this.isSidebarCollapsed
        }
    }

    closeMobileSidebar() {
        this.isMobileSidebarOpen = false
    }
}
